<template>
  <CRow>
    <CCol>
      <CCard>
        <CCardHeader>Account Detail</CCardHeader>
        <CCardBody>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                label="Account Group"
                :options="optionsAccountGroup"
                type="options"
                required
                v-model="accountData.account_group"
                @input="handleAccoutnGroup"
              />
            </CCol>
            <CCol :col="6">
              <CInput
                type="text"
                required
                label="Account Name"
                class="mb-0"
                placeholder="Account Name"
                v-model.trim="accountData.account_name"
                @change="handleAccountName"
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CInput
                label="Username"
                class="mb-0"
                placeholder="Username"
                v-model.trim="accountData.username"
                disabled
              />
            </CCol>
            <CCol :col="6">
              <CInput
                label="Email"
                class="mb-0"
                placeholder="Email"
                v-model.trim="accountData.email"
                disabled
              />
            </CCol>
          </CRow>
          <CRow class="form-group">
            <CCol :col="6">
              <CSelect
                type="text"
                required
                label="Status"
                :options="optionsStatus"
                v-model.trim="accountData.status"
                @input="handleStatus"
              />
            </CCol>
            <CCol :col="6">
              <CSelect
                label="Position"
                :options="positions"
                v-model="accountData.position"
                @change="handleAccountPosition"
              />
            </CCol>
          </CRow>
        </CCardBody>
        <CCardFooter>
          <CRow>
            <CCol sm="5">
              <CButton color="primary" @click="goBack">Back</CButton>
            </CCol>
            <CCol sm="7" class="d-none d-md-block">
              <CButton color="success" class="float-right" @click="update"
                >Update</CButton
              >
            </CCol>
          </CRow>
        </CCardFooter>
      </CCard>
    </CCol>
  </CRow>
</template>

<script>
// import usersData from './UsersData'
import axios from "axios";
import jwt from "jsonwebtoken";
import Swal from "sweetalert2";

export default {
  name: "User",

  data() {
    return {
      accountData: {},
      optionsAccountGroup: [
        "ADMINISTARTOR",
        "NPOS",
        "SALES",
        "HRD",
        "MARKETING",
        "QC",
        "COMMUNITY",
      ],
      optionsStatus: ["ACTIVE", "BANNED"],
      positions: ["LEAD", "STAFF"],
      domain: process.env.VUE_APP_DOMAIN_URL,
      token: "Bearer " + localStorage.getItem("token"),
    };
  },
  mounted() {
    this.authentication();
  },
  computed: {
    fields() {
      return [
        { key: "key", label: this.username, _style: "width:150px" },
        { key: "value", label: "", _style: "width:150px;" },
      ];
    },
  },
  methods: {
    getDataById() {
      let accountID = this.$route.params.id;
      axios
        .get(`${this.domain}/v1/account/${accountID}`, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          this.accountData = response.data;
        })
        .catch((e) => {
          console.log(e);
        });
    },
    authentication() {
      const data = jwt.decode(localStorage.getItem("token"));
      if (
        data.account_group === "ADMIN" ||
        data.account_group === "ADMINISTRATOR"
      ) {
        return null;
      } else {
        this.$router.push({ path: `/` });
      }
    },
    goBack() {
      this.usersOpened
        ? this.$router.go(-1)
        : this.$router.push({ path: "/management/account" });
    },
    handleAccoutnGroup(event) {
      this.accountData.account_group = event.target.value;
    },
    handleAccountName(event) {
      this.accountData.account_name = event;
    },
    handleStatus(event) {
      this.accountData.status = event.target.value;
    },
    handleAccountPosition(event) {
      this.accountData.position = event.target.value;
    },
    update() {
      let accountID = this.$route.params.id;
      axios
        .put(`${this.domain}/v1/account/${accountID}`, this.accountData, {
          headers: {
            Authorization: this.token,
            "Content-Type": "application/json",
          },
        })
        .then((response) => {
          // JSON responses are automatically parsed.
          Swal.fire({
            icon: "success",
            title: `Account Data Updated`,
            showConfirmButton: false,
            timer: 2000,
          });
          this.items = response.data;
          this.$router.push({ path: `/management/account` });
        })
        .catch((err) => {
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: err.response.data.message.id,
          });
          console.log(err);
        });
    },
  },
};
</script>

<style scoped>
@import "./User.css";
</style>
